/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_ClientInputs */

const en_cmp_row_client = /** @type {(inputs: Cmp_Row_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client mode / proposal`)
};

const id_cmp_row_client = /** @type {(inputs: Cmp_Row_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode klien / proposal`)
};

/**
* | output |
* | --- |
* | "Client mode / proposal" |
*
* @param {Cmp_Row_ClientInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_client = /** @type {((inputs?: Cmp_Row_ClientInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_ClientInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_client(inputs)
	return en_cmp_row_client(inputs)
});